import { render, staticRenderFns } from "./goldCoing.vue?vue&type=template&id=28c5ba2f&scoped=true"
import script from "./goldCoing.vue?vue&type=script&lang=js"
export * from "./goldCoing.vue?vue&type=script&lang=js"
import style0 from "./goldCoing.vue?vue&type=style&index=0&id=28c5ba2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c5ba2f",
  null
  
)

export default component.exports